'use strict';

const _=require('pulsar-utils/dist-es6/_');
const SortExtensions=require('../../../../../../dist-es6/client/extensions/sortExtensions');
const BaseController=require('../../../../../../dist-es6/client/angularCommon/baseController');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

FleetListDirective=class FleetListDirective extends BaseControllerBackedDirective{
get templateUrl(){
return'/templates/features/fleetInsight/components/fatigueTrends/fleetListView';
}

get controller(){
return FleetListController;
}};let


FleetListController=class FleetListController extends BaseController{
static get $inject(){
return['fatigueTrendsDataService','userService','uncaughtErrorHandler'];
}

constructor(fatigueTrendsDataService,userService,uncaughtErrorHandler){
super(uncaughtErrorHandler);
this._fatigueTrendsDataService=fatigueTrendsDataService;

this._sortByDescendingAvgFatigueOnDuty=SortExtensions(this._sortByAverageFatigueOnDuty).invert();

this.columnDefinitions=[{
label:'Average',
isInitiallyActive:!0,
defaultAscending:!1,
orderBy:[this._sortByAverageFatigueOnDuty],
finalSort:['name'],
columnClass:'average-fatigue-column'},
{
label:'Name',
defaultAscending:!0,
orderBy:['name'],
finalSort:[this._sortByDescendingAvgFatigueOnDuty],
columnClass:'name-column'},

{
label:'Duty Hours',
defaultAscending:!1,
orderBy:['dutyHours'],
finalSort:[this._sortByDescendingAvgFatigueOnDuty,'name'],
columnClass:'duty-hours-column'},

{
label:'Peak',
defaultAscending:!1,
orderBy:[this._sortByMaxFatigueOnDuty],
finalSort:[this._sortByDescendingAvgFatigueOnDuty,'name'],
columnClass:'peak-fatigue-column'},
{

columnClass:'filler-column'}];

}

_sortByMaxFatigueOnDuty(row){
return _.exists(row.maxFatigueOnDuty)?Math.floor(row.maxFatigueOnDuty):Number.NEGATIVE_INFINITY;
}

_sortByAverageFatigueOnDuty(row){
return _.exists(row.averageFatigueOnDuty)?Math.floor(row.averageFatigueOnDuty):Number.NEGATIVE_INFINITY;
}

get personRowModels(){

return _.get(this._fatigueTrendsDataService,'selectedGroupData.aggregatePersons')||[];
}};


module.exports=FleetListDirective;
//# sourceMappingURL=fleetListDirective.js.map
